// extracted by mini-css-extract-plugin
export default {"cls1":"a82Ifj8Y_ffl_nDuNMtM","cls2":"yS2XCIvBz16u2Alk32HT a82Ifj8Y_ffl_nDuNMtM"};